import * as React from 'react';
import { Image } from '@grandvisionhq/common';

const SizeGuide = ({ sizeGuideSizeCompound  })=>{
    if (!sizeGuideSizeCompound) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "size-guide"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "size-guide__container"
    }, sizeGuideSizeCompound.map((item)=>/*#__PURE__*/ React.createElement("li", {
            className: "size-guide__item",
            key: item.size
        }, /*#__PURE__*/ React.createElement(Image, {
            alt: item.image.description || '',
            className: "size-guide__image",
            url: item.image.url
        }), /*#__PURE__*/ React.createElement("div", {
            className: "size-guide__size"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "size-guide__size-titles"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "size-guide__size-title"
        }, item.size), /*#__PURE__*/ React.createElement("div", {
            className: "size-guide__size-specs"
        }, item.width)), /*#__PURE__*/ React.createElement("div", {
            className: "size-guide__size-description"
        }, item.description)))
    )));
};

export { SizeGuide as default };
//# sourceMappingURL=SizeGuide.js.map
